import { render, staticRenderFns } from "./EmpleadoPermiso.vue?vue&type=template&id=a018f690"
import script from "./EmpleadoPermiso.vue?vue&type=script&lang=js"
export * from "./EmpleadoPermiso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports